export default "__VITE_ASSET__a8e250c5__"